module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_2_2.f7fc65f1.png";